import { AnalyticsServiceInterface } from '~/modules/Analytics/Domain/AnalyticsServiceInterface'
import { IdentifyAnalyticsDto } from '~/modules/Analytics/Domain/IdentifyAnalyticsDto'
import {
  TrackCheckoutStartedDto, TrackProductMemoryCreatedDto, TrackProductMemoryRemovedDto, TrackProductMintedDto,
  TrackProductPurchasedDto, TrackProductSharedDto, TrackProductViewedDto
} from '~/modules/Analytics/Domain/TrackAnalyticsDto'
import { TrackGalleryDto } from '~/modules/Analytics/Domain/TrackGalleryDto'
import { BrowserAnalyticsClient } from './browserAnalyticsRuntime'

export class BrowserAnalyticsService implements AnalyticsServiceInterface {
  private analyticsClient: BrowserAnalyticsClient

  constructor (analyticsClient: BrowserAnalyticsClient) {
    this.analyticsClient = analyticsClient
  }

  async identify (identifyDto: IdentifyAnalyticsDto): Promise<void> {
    try {
      await this.analyticsClient.identify(identifyDto.id, {
        createdAt: identifyDto.createdAt,
        email: identifyDto.email,
        name: identifyDto.name,
      })
    } catch (exception: unknown) {
      console.error(exception)
    }
  }

  async trackCheckoutStarted (trackDto: TrackCheckoutStartedDto): Promise<void> {
    try {
      this.analyticsClient.track('Checkout Started', trackDto)
    } catch (exception: unknown) {
      console.error(exception)
    }
  }

  async trackProductPurchased (trackDto: TrackProductPurchasedDto): Promise<void> {
    try {
      this.analyticsClient.track('Product Purchased', trackDto)
    } catch (exception: unknown) {
      console.error(exception)
    }
  }

  async trackProductShared (trackDto: TrackProductSharedDto): Promise<void> {
    try {
      this.analyticsClient.track('Product Shared', trackDto)
    } catch (exception: unknown) {
      console.error(exception)
    }
  }

  async trackProductViewed (viewedDto: TrackProductViewedDto): Promise<void> {
    try {
      this.analyticsClient.track('Product Viewed', viewedDto)
    } catch (exception: unknown) {
      console.error(exception)
    }
  }

  async trackProductMinted (mintedDto: TrackProductMintedDto): Promise<void> {
    try {
      this.analyticsClient.track('Product Minted', mintedDto)
    } catch (exception: unknown) {
      console.error(exception)
    }
  }

  async trackProductMemoryRemoved (trackDto: TrackProductMemoryRemovedDto): Promise<void> {
    try {
      this.analyticsClient.track('Memory Removed', trackDto)
    } catch (exception: unknown) {
      console.error(exception)
    }
  }

  async trackProductMemoryCreated (trackDto: TrackProductMemoryCreatedDto): Promise<void> {
    try {
      this.analyticsClient.track('Memory Created', trackDto)
    } catch (exception: unknown) {
      console.error(exception)
    }
  }

  async trackGalleryEnabled (galleryDto: TrackGalleryDto): Promise<void> {
    try {
      this.analyticsClient.track('Gallery Enabled', galleryDto)
    } catch (exception: unknown) {
      console.error(exception)
    }
  }

  async trackGalleryDisabled (galleryDto: TrackGalleryDto): Promise<void> {
    try {
      this.analyticsClient.track('Gallery Disabled', galleryDto)
    } catch (exception: unknown) {
      console.error(exception)
    }
  }

  async trackGalleryViewed (galleryDto: TrackGalleryDto): Promise<void> {
    try {
      this.analyticsClient.track('Gallery Viewed', galleryDto)
    } catch (exception: unknown) {
      console.error(exception)
    }
  }
}
